import {
  DRAG_DROP_SORT_STRATEGY,
  DragDropProvider,
  DragDropSortableList,
} from '../../../DragDrop'
import { Content } from '../../../Modal'
import { DocFlowEditSequenceModalDraggableItem } from '../DocFlowEditSequenceModalDraggableItem'

import * as styles from './DocFlowEditSequenceModalContent.module.css'

function DocFlowEditSequenceModalContent({
  isLoading,
  notificationList,
  updatedList,
  onDragEnd,
}) {
  const itemIds = updatedList?.map(listItem => listItem.id.toString())

  return (
    <Content contentWrapperClassName={styles.contentWrapper}>
      {notificationList}

      <DragDropProvider onDragEnd={onDragEnd}>
        <DragDropSortableList
          items={itemIds}
          strategy={DRAG_DROP_SORT_STRATEGY.vertical}
        >
          {updatedList?.map(listItem => (
            <DocFlowEditSequenceModalDraggableItem
              {...listItem}
              isLoading={isLoading}
              key={listItem.id}
            />
          ))}
        </DragDropSortableList>
      </DragDropProvider>
    </Content>
  )
}

export default DocFlowEditSequenceModalContent
